export class ProductForm extends window.BAO.CustomElement() {
  async connectedCallback () {
    super.connectedCallback()

    this.completeTheStyleTracking()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  completeTheStyleTracking () {
    const isCtsProduct = new URLSearchParams(window.location.search).has('cts')

    if (!isCtsProduct) return

    const propertyEl = this.els['complete-the-style-property']?.element

    if (propertyEl) {
      propertyEl.disabled = false
      propertyEl.value = 'true'
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    this.toggleButtonText()
    await this.addToCart()
  }

  async addToCart () {
    try {
      await window.BAO.Cart.addItemFromForm(this.form)
    } catch (error) {
      console.error('Error adding item to cart:', error)
    }
  }

  toggleButtonText () {
    const buttonText = this.querySelector('[data-product-add-to-cart-text]')

    if (
      !buttonText ||
      !window.variantStrings.addToCart ||
      !window.variantStrings.added
    ) {
      return
    }

    buttonText.innerText = window.variantStrings.added

    window.setTimeout(() => {
      buttonText.innerText = window.variantStrings.addToCart
    }, 3000)
  }

  get id () {
    const formData = new FormData(this.form)

    return formData.get('id')
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
